// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"378adb0a","132":"ed6b0a22","160":"7d4c8b7b"}[chunkId] + ".chunk.js";
};